import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

document.querySelectorAll('.calculator-root').forEach((el) => {
    const props = {
        loanAmountLabel: el.dataset.loanAmountLabel || window.appConfig?.loanAmountLabel,
        monthlyLabel: el.dataset.monthlyLabel || window.appConfig?.monthlyLabel,
        durationLabel: el.dataset.durationLabel || window.appConfig?.durationLabel,
        infoLinkLabel: el.dataset.infoLinkLabel || window.appConfig?.infoLinkLabel,
        submitLabel: el.dataset.submitLabel || window.appConfig?.submitLabel,
        footerText: el.dataset.footerText || window.appConfig?.footerText,
        apiUrl: el.dataset.apiUrl || window.appConfig?.apiUrl,
        applyUrl: el.dataset.applyUrl || window.appConfig?.applyUrl,
        offerId: el.dataset.offerId || window.appConfig?.offerId,
        loginLabel: el.dataset.loginLabel || window.appConfig?.loginLabel,
        apiErrorMessage: el.dataset.apiErrorMessage || window.appConfig?.apiErrorMessage,
        monthsLabel: el.dataset.monthsLabel || window.appConfig?.monthsLabel,
        numDecimalMonthly: el.dataset.numDecimalMonthly || window.appConfig?.numDecimalMonthly,
    };
    if (!el._reactRoot) {
        const root = createRoot(el);
        root.render(
            <React.StrictMode>
                <App {...props} />
            </React.StrictMode>
        );
        el._reactRoot = root;
    }
});
